import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ErrorMessage, Spinner } from '../base';

/*
 * JSX function that checks error and data fields of property "input" and possibly renders an ErrorMessage or a Spinner.
 */
function widgetWrapper(Child) {

  class Widget extends PureComponent {

    static defaultProps = {
      input: {
        error: null,
        data: null,
      },
    };

    static propTypes = {
      input: PropTypes.shape({
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        data: PropTypes.object,
      }),
    };

    render() {
      const { input = null, ...anyOtherProps } = this.props;
      if (input) {
        const {
          error = null,
          data = null,
        } = input;
        if (error) {
          return <ErrorMessage error={error} />;
        }
        if (!data) {
          return <Spinner />;
        }
        return React.createElement(Child, { ...data, ...anyOtherProps });
      }
      return <Spinner />;
    }
  }

  return Widget;
}

export default widgetWrapper;
